import React, { lazy } from 'react';
const bonuses = [{
  num: '1',
  img: 'https://cdn.magicpatterns.com/uploads/vx3YXYP1czhLzJJaWK2J2C/3o_rituales.webp',
  title: '30 Rituales de Apertura y Cierre',
  value: '$19'
}, {
  num: '2',
  img: 'https://cdn.magicpatterns.com/uploads/gP7R1ZRT6y5xrjycprB5U4/guia_musical.webp',
  title: 'Guía de Música para tus Clases',
  value: '$19'
}, {
  num: '3',
  img: 'https://cdn.magicpatterns.com/uploads/5cKfowoVzzH3b7WqvAD4bj/ajustes_y_asistencias_fisicas.webp',
  title: 'Guía de Ajustes y Asistencias',
  value: '$19'
}, {
  num: '4',
  img: 'https://cdn.magicpatterns.com/uploads/sRX5GZgeciKyemzybKBdND/60_caption_ig.webp',
  title: '60 Captions de Instagram',
  value: '$19'
}, {
  num: '5',
  img: 'https://cdn.magicpatterns.com/uploads/toErsPd1NznRgn4SptH77Q/cuaderno_del_profesor_.webp',
  title: 'Tracker Anual del Profesor',
  value: '$19'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <div className="text-center mb-12" data-id="element-17">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-18">
            🎁 5 Bonos Exclusivos
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-19">
            Valorados en{' '}
            <span className="line-through text-secondary" data-id="element-20">$95 USD</span> —
            Incluidos <span className="font-bold text-primary" data-id="element-21">GRATIS</span>
          </p>
        </div>

        <div className="space-y-4" data-id="element-22">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light flex items-center gap-4 sm:gap-6 shadow-sm" data-id="element-23">
              <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm sm:text-base flex-shrink-0" data-id="element-24">
                {bonus.num}
              </div>
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl overflow-hidden flex-shrink-0 border border-border-light bg-bg-main" data-id="element-25">
                <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-26" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-27">
                <h3 className="text-text-main font-bold text-base sm:text-lg leading-tight mb-1" data-id="element-28">
                  {bonus.title}
                </h3>
                <div className="flex items-center gap-2 text-sm sm:text-base" data-id="element-29">
                  <span className="text-secondary line-through font-medium" data-id="element-30">
                    {bonus.value}
                  </span>
                  <span className="text-primary font-bold" data-id="element-31">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}